@if (loggedIn()) {
  <div class="flex flex-col grow justify-center items-center -translate-y-32">
    <mat-spinner class="m-2" color="primary" [diameter]="96"></mat-spinner>
    <label class="m-2">{{ translations.logout.signingOut.label.text }}</label>
  </div>
} @else {
  <div class="flex flex-col grow justify-center items-center -translate-y-32">
    <div class="py-2">{{ translations.logout.signedOut.label.text }}</div>
    <button modus-flat-button color="primary" (click)="login()">
      {{ translations.logout.signIn.button.text }}
    </button>
  </div>
}
